var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverdueAmountKpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 43,
    viewBox: "0 0 39 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250698",
    d: "M14.0156 41.5C18.4978 42.1403 21.4973 41.8215 25.5156 41.5C38.0156 40.5 38.0156 29 38.0156 29H1.01563C1.01563 29 0.0156231 39.5 14.0156 41.5Z",
    fill: "#BABFFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250703",
    d: "M15.0156 10H24.5156L28.0156 1.5H11.0156L15.0156 10Z",
    fill: "#BABFFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250702",
    d: "M11.0156 1L15.0156 10C15.0156 10 1.0156 20.0095 1.01562 29C1.01565 38 7.01572 40.7222 14.0156 41.5C18.5156 42 21.5156 42 25.5156 41.5C32.3659 40.6437 38.0156 37 38.0156 29C38.0156 20.1183 24.5156 10 24.5156 10L28.5156 1H11.0156Z",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250700",
    d: "M13.5156 10H26.0156",
    stroke: "#383434",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 749",
    cx: 19.5156,
    cy: 22.5,
    r: 4,
    stroke: "#383434",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdueAmountKpi);
export default __webpack_public_path__ + "static/media/overdue_Amount_KPI.02c760359abfa4e1cab74e1378fe9124.svg";
export { ForwardRef as ReactComponent };